// extracted by mini-css-extract-plugin
export default {"pill":"EventPill_pill__qo3aC"};